import { useRef, useState } from "react";

export default function TypeTravoPage({ work, onClose, onUpdate, allWorks }) {
  const [currentWork, setCurrentWork] = useState(work);
  const [types, setTypes] = useState(work.types || []);
  const [showAddForm, setShowAddForm] = useState(false);
  const [editingType, setEditingType] = useState(null);
  const [newType, setNewType] = useState({
    name: "",
    description: "",
    image: "",
    isActive: true
  });
  const trackRef = useRef(null);

  // =========================
  // FUNCTIONS
  // =========================

  const selectWork = (selectedWork) => {
    if (selectedWork) {
      setCurrentWork(selectedWork);
      setTypes(selectedWork.types || []);
    }
  };

  const scrollCarousel = (dir) => {
    const el = trackRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * 320, behavior: "smooth" });
  };

  const handleAddType = () => {
    if (!newType.name) return;

    const typeToAdd = {
      id: Date.now(),
      ...newType
    };

    const updatedTypes = [...types, typeToAdd];
    setTypes(updatedTypes);
    
    const updatedWork = { ...currentWork, types: updatedTypes };
    onUpdate(updatedWork);
    
    setNewType({ name: "", description: "", image: "" });
    setShowAddForm(false);
  };

  const handleEditType = (type) => {
    setEditingType(type);
    setNewType({
      name: type.name,
      description: type.description,
      image: type.image,
      isActive: type.isActive !== undefined ? type.isActive : true
    });
    setShowAddForm(true);
  };

  const handleUpdateType = () => {
    if (!newType.name) return;

    const updatedTypes = types.map((type) =>
      type.id === editingType.id
        ? { ...type, ...newType }
        : type
    );

    setTypes(updatedTypes);
    
    const updatedWork = { ...currentWork, types: updatedTypes };
    onUpdate(updatedWork);
    
    setNewType({ name: "", description: "", image: "" });
    setEditingType(null);
    setShowAddForm(false);
  };

  const handleDeleteType = (typeId) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer ce type ?")) {
      const updatedTypes = types.filter((type) => type.id !== typeId);
      setTypes(updatedTypes);
      
      const updatedWork = { ...currentWork, types: updatedTypes };
      onUpdate(updatedWork);
    }
  };

  const cancelForm = () => {
    setNewType({ name: "", description: "", image: "", isActive: true });
    setEditingType(null);
    setShowAddForm(false);
  };

  const toggleTypeStatus = (typeId) => {
    const updatedTypes = types.map((type) =>
      type.id === typeId ? { ...type, isActive: !type.isActive } : type
    );
    setTypes(updatedTypes);
    const updatedWork = { ...currentWork, types: updatedTypes };
    onUpdate(updatedWork);
  };

  return (
    <div className="type-travo-overlay" onClick={onClose}>
      <div className="type-travo-panel" onClick={(e) => e.stopPropagation()}>
        
        <div className="type-travo-header">
          <div>
            <h2>Gestion des types</h2>
            <div className="work-carousel">
              <button
                type="button"
                className="carousel-btn prev"
                onClick={() => scrollCarousel(-1)}
                aria-label="Précédent"
              >
                ‹
              </button>
              <div className="carousel-track" ref={trackRef}>
                {allWorks.map((w) => (
                  <div
                    key={w.id}
                    className={`work-chip ${currentWork.id === w.id ? "active" : ""}`}
                    onClick={() => selectWork(w)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") selectWork(w);
                    }}
                  >
                    
                    <div className="chip-info">
                      <span className="chip-name">{w.name}</span>
                    </div>
                  </div>
                ))}
              </div>
              <button
                type="button"
                className="carousel-btn next"
                onClick={() => scrollCarousel(1)}
                aria-label="Suivant"
              >
                ›
              </button>
            </div>
          </div>
          <button className="close-panel-btn" onClick={onClose}>×</button>
        </div>

        {/* ADD TYPE BUTTON */}
        {!showAddForm && (
          <button className="add-type-main-btn" onClick={() => setShowAddForm(true)}>
            <span>+</span> Ajouter un type
          </button>
        )}

        {/* ADD/EDIT FORM */}
        {showAddForm && (
          <div className="type-form-container">
            <h3>{editingType ? "Modifier le type" : "Nouveau type"}</h3>
            
            <input
              type="text"
              placeholder="Nom du type"
              value={newType.name}
              onChange={(e) => setNewType({ ...newType, name: e.target.value })}
            />
            
            <textarea
              placeholder="Description"
              rows="3"
              value={newType.description}
              onChange={(e) => setNewType({ ...newType, description: e.target.value })}
            />
            
            <input
              type="text"
              placeholder="URL de l'image"
              value={newType.image}
              onChange={(e) => setNewType({ ...newType, image: e.target.value })}
            />

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
              <input
                type="checkbox"
                id="isActiveType"
                checked={newType.isActive}
                onChange={(e) => setNewType({ ...newType, isActive: e.target.checked })}
                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
              />
              <label htmlFor="isActiveType" style={{ cursor: 'pointer', fontSize: '14px' }}>Activer le type</label>
            </div>

            {newType.image && (
              <div className="image-preview">
                <img src={newType.image} alt="Prévisualisation" />
              </div>
            )}

            <div className="form-actions">
              <button 
                className="save-type-btn"
                onClick={editingType ? handleUpdateType : handleAddType}
              >
                {editingType ? "Modifier" : "Ajouter"}
              </button>
              <button className="cancel-type-btn" onClick={cancelForm}>
                Annuler
              </button>
            </div>
          </div>
        )}

        {/* TYPES LIST */}
        <div className="types-list-container">
          <h3>Liste des types ({types.length})</h3>
          
          {types.length === 0 ? (
            <div className="empty-types">
              <p>Aucun type pour ce travail</p>
              <p className="empty-sub">Cliquez sur "Ajouter un type" pour commencer</p>
            </div>
          ) : (
            <div className="types-grid-panel">
              {types.map((type) => (
                <div key={type.id} className="type-card-panel">
                  <img src={type.image || "https://via.placeholder.com/300"} alt={type.name} />
                  
                  <div className="type-card-content">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <h4>{type.name}</h4>
                      <span 
                        className={`badge ${type.isActive !== false ? 'active' : 'inactive'}`}
                        onClick={() => toggleTypeStatus(type.id)}
                        style={{ cursor: 'pointer', transform: 'scale(0.8)' }}
                      >
                        {type.isActive !== false ? 'Actif' : 'Inactif'}
                      </span>
                    </div>
                    <p>{type.description}</p>
                  </div>

                  <div className="type-card-actions">
                    <button 
                      className="edit-type-btn"
                      onClick={() => handleEditType(type)}
                    >
                      Modifier
                    </button>
                    <button 
                      className="delete-type-btn"
                      onClick={() => handleDeleteType(type.id)}
                    >
                      Supprimer
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
